import { render, staticRenderFns } from "./ColunaListaProdutos.vue?vue&type=template&id=66b41b48&scoped=true&"
import script from "./ColunaListaProdutos.vue?vue&type=script&lang=js&"
export * from "./ColunaListaProdutos.vue?vue&type=script&lang=js&"
import style0 from "./ColunaListaProdutos.vue?vue&type=style&index=0&id=66b41b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b41b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
